import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CommonService} from './common.service';
import {HttpClient} from '@angular/common/http';
import {Socket} from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})
export class AgreementsService {
  public insertedAgreements: Observable<any>;

  constructor(private commonService: CommonService,
              private httpClient: HttpClient,
              private socket: Socket) {
    this.insertedAgreements = this.socket.fromEvent<any>('insertAgreement');

  }
}
